import { debounce } from 'lodash-es'
import { ElMessage } from 'element-plus'
import { guessFetchError, guessZodError } from '#imports'

export default defineNuxtPlugin((nuxtApp) => {
  // window.onerror = (message, source, lineno, colno, error) => {
  //   console.log('window.onerror', { message, source, lineno, colno, error })
  //   handleError(error)
  // }

  if (process.client) {
    let isHandling = false

    window.addEventListener('unhandledrejection', (event) => {
      if (isHandling)
        return
      isHandling = true
      console.log('window.unhandledrejection', event)
      handleError(event.reason)
      isHandling = false
    })

    window.onunhandledrejection = (event) => {
      if (isHandling)
        return
      isHandling = true
      console.log('window.unhandledrejection', event)
      handleError(event.reason)
      isHandling = false
    }

    nuxtApp.hook('vue:error', (error: any, instance, info) => {
      if (isHandling)
        return
      isHandling = true
      console.log('Vue Error', { error, instance, info })
      handleError(error)
      isHandling = false
    })
  }
})

const showError = debounce(msg => ElMessage.error(msg), 100)

function handleError(error: any) {
  if (error === 'cancel')
    return

  if (error.message === '__ignore__')
    return

  if ((error)?.name === 'FetchError') {
    let message = ''
    if (error.data?.data?.name === 'ZodError')
      message = guessZodError(error.data.data)
    else
      message = guessFetchError(error)

    showError(message)

    if (error.status === 403)
      navigateTo({ path: '/home', replace: true })
    else if (error.status === 401)
      navigateTo({ path: '/login', replace: true })
  }
  else if (typeof error === 'object') {
    // check element form validator error shape
    if (Object.keys(error).every((key: any) => Array.isArray(error[key])))
      return

    showError(error.message || JSON.stringify(error))
  }
  else {
    showError(error?.message || '未知错误')
  }
}
